module.exports = __webpack_public_path__ + "static/media/newGarden.2df96159.jpeg";